module.exports = __webpack_public_path__ + "news-image-01.jpg?26ee88a69097de90451b5ad39f19648a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-image-01.jpg
// module id = 238
// module chunks = 0